import { FlexBox } from '@ardoq/layout';

export const PopoverListItem = ({ text }: { text: string }) => (
  <FlexBox gap="small" align="baseline">
    &bull;
    <span>{text}</span>
  </FlexBox>
);
